import type { ComponentPropsWithoutRef } from 'react';

import styles from './visual-modal-body.component.module.scss';

type Props = {
  layout?: 'center' | 'left';
} & ComponentPropsWithoutRef<'div'>;

export const VisualModalBody = ({
  children,
  layout = 'center',
  className,
  ...rest
}: Props) => {
  return (
    <div
      className={[className, styles.visualModalBody].filter(Boolean).join(' ')}
      data-layout={layout}
      {...rest}
    >
      {children}
    </div>
  );
};
